module.exports = require("react-dimensions");


/*****************
 ** WEBPACK FOOTER
 ** external "react-dimensions"
 ** module id = 104
 ** module chunks = 0
 **/